<!-- 工作台 -->
<template>
    <div v-loading="loading">
        <div class="set-content">
            <div v-for="item in columnData" :key="item.ColumnCode" class="set-item">
                <el-checkbox :disabled="!item.IsCanSet" :checked="item.IsShow" v-model="item.IsShow" border class="item-canset"></el-checkbox>
                <el-input v-model="item.Title" class="item-cname"></el-input>
                <el-input v-if="!item.IsJointSearch" v-model="item.Placeholder" class="item-width">
                    <template popper-class="item-width-title" slot="prepend">输入提示</template>
                </el-input>
                <el-button v-else class="item-width" type="primary" plain @click="jointSets">设置查询条件</el-button>
            </div>
        </div>
        <div slot="footer" class="dialog-footer" style="text-align: right; margin-top: 20px; padding-bottom: 10px">
            <el-button class="search-btn" type="warning" @click="restoreDefault">恢复默认</el-button>
            <el-button class="search-btn" @click="closeDialog(false)">取消</el-button>
            <el-button class="search-btn btn-primary" @click="submit">保存设置</el-button>
        </div>
        <el-dialog :close-on-click-modal="false" title="自定义搜索条件展示设置" @close="closeJointDialog" :visible.sync="jointSetVisible" append-to-body width="600px">
            <div class="dialog-content" v-if="jointSetVisible">
                <jointSets @closeDialog="closeJointDialog"></jointSets>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import jointSets from '@/components/common/jointSets.vue';
export default {
    name: '',
    props: ['tableCode'],
    components: { jointSets },
    data() {
        return {
            columnData: {},
            loading: false,
            jointSetVisible: false
        };
    },
    created() {},
    mounted() {
        this.getSetsData();
    },
    methods: {
        getSetsData() {
            this.loading = true;
            this.$util.getSearchCrtSetsData(this.tableCode, false).then(data => {
                this.columnData = data;
                this.loading = false;
            });
        },
        submit() {
            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpInfoManagement/SubmitStaffSearchCriteriaSets',
                    data: { PageCode: this.tableCode, SearchSetsData: this.columnData },
                    hideLoading: true
                })
                .then(res => {
                    this.$util.successMsg(res.errmsg);
                    this.$util.clearLocalStorage('ss_' + this.tableCode);
                    this.closeDialog(true);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        restoreDefault() {
            this.loading = true;
            this.$util
                .axiosPost({
                    url: `/api/EntpInfoManagement/RestoreDefaultSearchCriteriaSets?tableCode=${this.tableCode}`,
                    hideLoading: true
                })
                .then(res => {
                    this.$util.successMsg(res.errmsg);
                    this.$util.clearLocalStorage('ss_' + this.tableCode);
                    this.closeDialog(true);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        closeDialog(isEdit) {
            this.$emit('closeDialog', isEdit);
        },
        jointSets() {
            this.jointSetVisible = true;
        },
        closeJointDialog() {
            this.jointSetVisible = false;
        }
    }
};
</script>
<style lang="less" scoped>
.set-content {
    display: flex;
    flex-direction: column;

    .set-item {
        display: flex;
        flex-direction: row;

        .item-canset {
            width: 7%;
            border-radius: 5px 0 0 5px;
        }

        .item-cname {
            width: 30%;
        }

        .item-width {
            width: 63%;
        }
    }
    .el-input-group__prepend {
        padding: 0 10px;
        border-radius: 0;
    }
    .el-input-group__append {
        padding: 0 10px;
    }
    .el-input__inner {
        border-radius: 0;
    }
    .el-button {
        border-radius: 0;
    }
}
</style>
